import { useTranslation } from "react-i18next";

import { NotificationContainer } from "components/NotificationsCenter/components/ClaireNotification/components/NotificationContainer";

import type { NotificationRegistryConfig } from "components/NotificationsCenter/components";

type KeyLockerCallForHelpProps = {
  closeToast: () => void;
};

export const KeyLockerCallForHelpNotification = ({ closeToast }: KeyLockerCallForHelpProps) => {
  const { t } = useTranslation();

  return (
    <NotificationContainer
      icon="phone"
      title={t("v8_customer_is_calling_for_help_at_the_key_locker", "Customer is calling for help at the Key Locker")}
      description={t("v8_handle_call", "Handle call")}
      onCloseNotification={closeToast}
    />
  );
};

export const KeyLockerCallForHelpNotificationConfig: NotificationRegistryConfig = {
  toastOptions: { autoClose: false, style: { width: "400px", right: "80px" } },
  render: ({ closeToast }) => <KeyLockerCallForHelpNotification closeToast={closeToast} />
};
